import { setError, startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { CAP_APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/capApplicationsActionTypes';
import endpoints from '@constants/configs/endpoints';
import { IAppController, IApplications } from '@modules/members/types/Applications.interface';
import API from '@services/API';
import { logError } from '../../utils/tools/ErrorLoggers';
import { setUserConfidentiality, syncHouseholdReferenceId } from '../SideNav/sideNavActionCreators';
import { SPINNER_MESSAGES_IDS } from '../../constants/common/miscellaneous';

const householdId = sessionStorage.getItem('encHouseHoldId') || localStorage.getItem('HK_encHouseholdId') || '';

export const setCapApplications = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_APPLICATIONS,
    payload: data,
});

export const setCurrentYear = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR,
    payload: data,
});

export const setCapController = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_CAP_CONTROLLER,
    payload: data,
});

export const setOutboundButtonStatus = data => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.SET_OUTBOUND_BUTTON_STATUS,
    payload: data,
});

export const setApplicationProperty = (caseNumber: string, property: string, value: boolean | string | number) => ({
    type: CAP_APPLICATIONS_ACTION_TYPES.UPDATE_APPLICATION_PROPERTY,
    payload: { caseNumber, property, value },
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchApplicationsDetails = (currentYear, _environment, callback?) => async dispatch => {
    dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
    try {
        const todayDateTime = new Date().getTime();
        const url = endpoints.MEMBER_APP_LIST_GET_APPS.processReplacements({
            coverageYear: currentYear,
            newDateTime: todayDateTime,
            encHouseholdId: householdId,
        });
        const applicationsData: IApplications = await API.getData(url, dispatch, actions, true);
        if (applicationsData) {
            dispatch(setCapApplications(applicationsData));

            if (applicationsData?.currentApplications?.length > 0) {
                const caseNumber = applicationsData?.currentApplications?.[0]?.caseNumber;
                const outBoundButtonStatusData = await API.getData(
                    endpoints.MEMBER_APP_LIST_OUTBOUND_BUTTON_STATUS.processReplacements({ caseNumber }),
                    dispatch,
                    actions,
                    true,
                );
                dispatch(setOutboundButtonStatus(outBoundButtonStatusData?.result));
            }
        } else {
            console.error('Cannot get cap applications details', url);
        }
        callback?.();
    } finally {
        dispatch(stopSpinner());
    }
};

export const fetchAppControllerInfo = (url, _environment) => async dispatch => {
    try {
        const data: IAppController = await API.getData(url, dispatch, actions, true);
        if (data && data.data) {
            dispatch(setCapController(data.data));
            // Validate household exists and has proper structure
            if (data.data.household && typeof data.data.household === 'object') {
                const isConfidential = data.data.household.confidential === true;
                dispatch(setUserConfidentiality(isConfidential));
                dispatch(syncHouseholdReferenceId(data.data.household));
            } else {
                logError('fetchAppControllerInfo: household data missing or invalid structure');
                dispatch(setUserConfidentiality(false));
            }
        } else {
            logError('Cannot get cap controller info', url);
            dispatch(setUserConfidentiality(false));
            dispatch(setError('Failed to load application controller information'));
        }
    } catch (error) {
        logError('fetchAppControllerInfo error:', error);
        dispatch(setUserConfidentiality(false));
        dispatch(setError('Failed to load application controller information'));
    }
};
